export const CONSTANTS = {
  ADD_NOTIFICATION: '@toast/ADD_NOTIFICATION',
  CLEAN_NOTIFICATIONS: '@toast/CLEAN_NOTIFICATIONS',
  REMOVE_NOTIFICATION: '@toast/REMOVE_NOTIFICATION',
};

export default CONSTANTS;
